import type { Contract } from "@/pages/human-resources/time-management/business/contract/Contract.ts";
import { partition, sortByKey } from "@/shared/utils/Arrays.ts";

export class EmployeeContracts {
  public readonly onMainSite: Contract[];
  public readonly onOtherSites: Contract[];
  constructor(mainSiteId: string, contracts: Contract[]) {
    const [mains, others] = partition(
      contracts,
      (c) => c.siteId === mainSiteId,
    );
    if (mains.length === 0) {
      throw new Error("No contract found");
    }
    sortByKey(mains, (c) => c.start.toISOString());
    sortByKey(others, (c) => c.start.toISOString());
    this.onMainSite = mains;
    this.onOtherSites = others;
  }

  public otherSitesIds(): Set<string> {
    return new Set(this.onOtherSites.map((c) => c.siteId));
  }

  public firstOnMainSite(): Contract {
    return this.onMainSite[0];
  }

  public findOnOtherSitesAtDate(date: Date): Contract[] {
    // TODO: Use this to try to display unmodifiable time slots on other sites.
    return this.onOtherSites.filter((c) => c.isEffectiveAtDate(date));
  }
}
